// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__3AMHy","title":"AfterBackImages_title__1K_lo","images":"AfterBackImages_images__356v3"};